export default {
	path: '/object-danger-occur-statistic-bar2',
	redirect: '/object-danger-occur-statistic-bar2',
	component: () => import('@/views/layout/Default'),
	children: [
		{
			path: '/',
			name: 'ObjectDangerOccurStatisticBar2Home',
			component: () => import('@/views/biz/ObjectDangerOccurStatisticBar2'),
		},
	],
};
